const click2PayRoutes = {
    onboarding: 'onboarding',
    termsAndConditions: 'onboarding/terms-and-conditions',
    infoReview: 'onboarding/info-review',
    chooseCard: 'onboarding/choose-card',
    summary: 'onboarding/summary',
    admin: 'admin',
};

export default click2PayRoutes;
